import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import ChartContainer from "@client.components/ChartContainer";
import DetailedTooltip from "./DetailedTooltip";

const ChartWithDetailedTooltip = ({
  title,
  className,
  dataSource,
  onError,
  renderChartContent,
  isHorizontal,
  getTooltipContent,
  renderRightComponent,
}) => {
  const [tooltipData, setTooltipData] = useState(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  let timeoutId = useRef(null);

  const handleBarMouseEnter = (data, _, e) => {
    clearTimeout(timeoutId.current);
    setTooltipVisible(true);

    const { x, y, width } = e.target.getBoundingClientRect();

    setTooltipData({
      ...data,
      barPosition: {
        x: isHorizontal ? e.clientX : x + width,
        y: isHorizontal ? y : e.clientY,
      },
    });
  };

  const handleBarMouseMove = (_q, _d, e) => {
    setTooltipData((prevState) => {
      return {
        ...prevState,
        barPosition: isHorizontal
          ? { ...prevState.barPosition, x: e.clientX }
          : { ...prevState.barPosition, y: e.clientY },
      };
    });
  };

  const handleBarMouseLeave = () => {
    timeoutId.current = setTimeout(() => {
      setTooltipVisible(false);
    }, 300);
  };

  const handleTooltipMouseEnter = () => {
    clearTimeout(timeoutId.current);
  };

  const handleTooltipMouseLeave = () => {
    setTooltipVisible(false);
  };

  if (dataSource.error) {
    onError(dataSource.error);
  }

  return (
    <ChartContainer
      title={title}
      renderRightComponent={renderRightComponent}
      className={className}
      isLoading={dataSource.load}
      data={dataSource.data}
    >
      <>
        {renderChartContent(
          handleBarMouseEnter,
          handleBarMouseMove,
          handleBarMouseLeave
        )}
        {tooltipData && tooltipVisible && (
          <DetailedTooltip
            {...tooltipData}
            getTooltipContent={getTooltipContent}
            onMouseEnter={handleTooltipMouseEnter}
            onMouseLeave={handleTooltipMouseLeave}
          />
        )}
      </>
    </ChartContainer>
  );
};

ChartWithDetailedTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  renderChartContent: PropTypes.func.isRequired,
  dataSource: PropTypes.any.isRequired,
  isHorizontal: PropTypes.bool.isRequired,
  getTooltipContent: PropTypes.func,
  renderRightComponent: PropTypes.func,
};

export default ChartWithDetailedTooltip;
